import WaitlistForm from "../components/WaitlistForm";
import Reveal from "../components/Reveal";

export default function OrphanSanctuary() {
  return (
    <>
      <section className="container-prose pt-16 sm:pt-24 pb-10 relative">
        <div
          aria-hidden
          className="orb -top-20 -right-20 h-72 w-72 animate-float"
          style={{ background: "radial-gradient(closest-side, #b0c7ff, transparent)" }}
        />
        <Reveal>
          <span className="pill pill-sky">Program 02 · Orphan Sanctuary</span>
          <h1 className="mt-5 font-display text-5xl sm:text-6xl leading-[1.02] text-balance">
            A home where every child has <em className="not-italic grad-text">someone waiting.</em>
          </h1>
          <p className="mt-6 text-lg text-ink-500 leading-relaxed">
            Our Orphan Sanctuary is a home for children without parents or
            guardians. Safe shelter, three meals a day, enrollment in school,
            after-hours tutoring, medical care, and adults who show up every
            day. No fees. No public shaming. Just a childhood.
          </p>
        </Reveal>
      </section>

      <section className="container-prose py-10">
        <div className="grid gap-5 sm:grid-cols-3">
          {[
            { h: "Who it's for", t: "Children up to 18 without parents or legal guardians, or in temporary state care awaiting placement." },
            { h: "What's included", t: "Shelter, food, schooling fees and uniform, books, tutoring, healthcare, counselling." },
            { h: "Legal path", t: "We work within Indian child-welfare law via the CWC and partner institutions. Intake is never informal." },
          ].map((b, i) => (
            <Reveal key={b.h} delay={i * 100}>
              <div className="surface h-full">
                <h3 className="font-display text-xl">{b.h}</h3>
                <p className="mt-2 text-ink-500 text-sm leading-relaxed">{b.t}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="container-prose py-10">
        <Reveal>
          <div className="glass-strong rounded-3xl p-8 sm:p-10 relative overflow-hidden">
            <div
              aria-hidden
              className="absolute -top-16 -left-16 h-56 w-56 rounded-full blur-3xl opacity-50"
              style={{ background: "radial-gradient(closest-side, #d7c8ff, transparent)" }}
            />
            <h2 className="font-display text-3xl">How intake works</h2>
            <ol className="mt-5 space-y-3 text-ink-700 text-sm">
              {[
                "A relative, guardian, social worker, or NGO joins the waitlist below.",
                "Our child-welfare lead calls to understand the case and legal status.",
                "We coordinate with the local Child Welfare Committee (CWC) on proper paperwork.",
                "When a place is ready and the legal path is clear, the child comes home.",
              ].map((step, i) => (
                <li key={i} className="flex gap-3 items-start">
                  <span className="shrink-0 mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-white text-sky-glow font-mono text-xs font-semibold border border-sky-200">
                    {i + 1}
                  </span>
                  <span className="leading-relaxed">{step}</span>
                </li>
              ))}
            </ol>
            <p className="mt-5 text-xs text-ink-500">
              Note: We do not accept children in ways that bypass legal
              guardianship procedures. This protects the child.
            </p>
          </div>
        </Reveal>
      </section>

      <section id="waitlist" className="container-prose pt-10 pb-24">
        <Reveal>
          <div className="mb-6">
            <h2 className="font-display text-4xl">
              Join the Orphan Sanctuary waitlist
            </h2>
            <p className="mt-3 text-ink-500 leading-relaxed">
              Submit on behalf of a child you are helping — as a relative,
              neighbour, social worker, NGO, or CWC officer. The more you
              share, the faster we can prepare a place.
            </p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <WaitlistForm program="orphan" />
        </Reveal>
      </section>
    </>
  );
}
